module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jZ3Sg"))).then(() => parcelRequire('dJXJK'));